
(function(){
  /* === SXF NUMBERED SERIES — the public official archive === (build 2026-09-02c) */
  var FOLDER_ID = "1blSr8Ug1kendXdAYM66udQzhF8UnvxaX";   /* 03 RESOURCES/01 SXF NUMBERED SERIES */
  var API_KEY   = "AIzaSyBCS9QF0IPlojZvXsqGAfUyWEiNR9oyueE";
  var mqMobile = window.matchMedia && window.matchMedia("(max-width:760px)");
  var isMobile = !!(mqMobile && mqMobile.matches);
  var BATCH = isMobile ? 40 : 80;
  if(mqMobile && mqMobile.addEventListener){ mqMobile.addEventListener("change", function(e){
    isMobile = e.matches; BATCH = isMobile ? 40 : 80; }); }   /* rotation re-evaluates */
  var $ = function(s){return document.querySelector(s);};
  var main=$("#av-main"), foldersEl=$("#av-folders"), crumbsEl=$("#av-crumbs"),
      countEl=$("#av-count"), qEl=$("#av-q"), sortEl=$("#av-sort"),
      subjEl=$("#av-subjects"), sizeEl=$("#av-sizes"), statsEl=$("#av-stats"), toastEl=$("#av-toast");
  var SUBJECTS={}, activeSubject=null, expandedParent=null;
  var CROPS={};  /* crops.json overlay: filename -> {box:[L,T,R,B], ar} — trims the white scanner-bed margin for display only */
  var SIZES={}, activeSize=null;  /* sizes.json overlay: filename -> "XS"|"S"|"M"|"L"|"XL" — size filter + smaller XS tiles */
  /* Ratio finder. RON = sort engaged; RTARGET = w/h being matched; RH pins the h box. */
  var RON=false, RTARGET=1, REITHER=false, RH=null, RBEST=null;   /* either OFF by default: a landscape search should show landscapes */
  var RTICKS=[["1:3",1/3],["9:16",9/16],["3:4",.75],["1:1",1],["4:3",4/3],["16:9",16/9],["3:1",3]];
  var META={};  /* meta.json overlay: filename -> dimensions/medium/support/year/size (legend-packed) */
  var IMG=function(m){return m && m.indexOf("image/")===0;};
  var FOLDER="application/vnd.google-apps.folder";
  var thumb=function(id){return "https://lh3.googleusercontent.com/d/"+id+"=w"+(isMobile?360:500);};
  var big=function(id){return "https://lh3.googleusercontent.com/d/"+id+"=w1800";};
  var dl=function(id){return "https://drive.google.com/uc?export=download&id="+id;};
  var path=[{id:FOLDER_ID, name:"All Drawings"}];
  var cache={}; var loadToken=0;
  var allFiles=[]; var view=[]; var currentImages=[]; var lbIndex=0;
  var rendered=0; var locked=false; var manual=false; var loadingDone=false;
  var wrap=null, rafPending=false;
  /* accession number = filename STARTING with the 6-digit stamp; archive-dated names -> null (never poison stats/sort) */
  function numOf(f){ if(f&&f._gnum!=null) return f._gnum; var m=/^(\d{6})/.exec(f.name||""); return m?parseInt(m[1],10):null; }
  function titleOf(f){ var n=numOf(f); return n!=null ? ("Drawing #"+("000000"+n).slice(-6)) : (f.name||""); }
  /* zine pages (path via Zines/<folder>) fold into one cover folder-tile; browsing INTO the folder spreads them */
  function zineOf(c){ for(var i=0;i<c.length-1;i++){ if(/^zines$/i.test(c[i]||"")) return c[i+1]; } return null; }
  function zKey(f){ var n=(f.name||"").toLowerCase();
    if(n.indexOf("front cover")>=0) return [0,0,0,""];
    if(n.indexOf("back cover")>=0) return [3,0,0,""];
    var m=/^(\d{6})(?:-(\d+))?/.exec(f.name||"");
    return m?[1,+m[1],m[2]?+m[2]:0,""]:[2,0,0,n]; }
  function makeZine(zn, files){
    var pgs=files.slice().sort(function(a,b){ var x=zKey(a),y=zKey(b);
      for(var i=0;i<3;i++){ if(x[i]!==y[i]) return x[i]-y[i]; } return x[3]<y[3]?-1:(x[3]>y[3]?1:0); });
    var cv=pgs[0], m=/\(([^)]+)\)/.exec(zn), d=/^(\d+)/.exec(zn);
    cv._group={label:m?m[1]:zn, files:pgs}; cv._gnum=d?+d[1]:null; return cv; }
  function toast(msg){ toastEl.textContent=msg; toastEl.classList.add("show");
    clearTimeout(toast._t); toast._t=setTimeout(function(){toastEl.classList.remove("show");},1800); }
  function escapeHtml(s){return (s||"").replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function listFolder(folderId){
    var files=[];
    function page(token){
      var params=new URLSearchParams({q:"'"+folderId+"' in parents and trashed=false",key:API_KEY,
        fields:"nextPageToken,files(id,name,mimeType,createdTime,size,imageMediaMetadata(width,height,rotation))",
        pageSize:"1000",orderBy:"folder,name",supportsAllDrives:"true",includeItemsFromAllDrives:"true"});
      if(token) params.set("pageToken",token);
      return fetch("https://www.googleapis.com/drive/v3/files?"+params.toString()).then(function(res){
        if(!res.ok){ return res.text().then(function(t){ throw new Error(res.status+": "+t); }); }
        return res.json();
      }).then(function(data){ files=files.concat(data.files||[]); if(data.nextPageToken) return page(data.nextPageToken); return files; });
    }
    return page(null);
  }
  function listCached(id){
    if(cache[id]) return Promise.resolve(cache[id]);
    return listFolder(id).then(function(items){
      var r={files:[],folders:[]};
      items.forEach(function(it){ (it.mimeType===FOLDER?r.folders:r.files).push(it); });
      var SZ={"Extra Small":1,"Small":2,"Medium":3,"Large":4,"X-Large":5};
      r.folders.sort(function(a,b){
        var an=a.name||"", bn=b.name||"";
        if(/^\d{4}$/.test(an)&&/^\d{4}$/.test(bn)) return bn.localeCompare(an); /* years newest-first */
        if(SZ[an]&&SZ[bn]) return SZ[an]-SZ[bn];                                /* sizes XS->XL */
        return an.localeCompare(bn);
      });
      cache[id]=r; return r;
    });
  }
  function renderCrumbs(){
    crumbsEl.innerHTML=path.map(function(p,i){ return i===path.length-1 ? "<span>"+escapeHtml(p.name)+"</span>" : '<a data-i="'+i+'">'+escapeHtml(p.name)+"</a>"; }).join('<span class="sep">/</span>');
    crumbsEl.querySelectorAll("a").forEach(function(a){ a.onclick=function(){ path=path.slice(0,+a.dataset.i+1); load(); }; });
  }
  function folderSvg(){return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>';}
  function renderFolders(folders){
    if(!folders.length){ foldersEl.innerHTML='<div class="av-empty-side">Showing every drawing.</div>'; return; }
    foldersEl.innerHTML="";
    folders.forEach(function(f){
      var d=document.createElement("div"); d.className="av-folder";
      d.innerHTML=folderSvg()+'<span>'+escapeHtml(f.name)+'</span>';
      d.onclick=function(){ path.push({id:f.id,name:f.name}); load(); };
      foldersEl.appendChild(d);
    });
  }
  /* INFO icon, not download — downloads are by right-click per the licensing model */
  function infoIcon(){return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><circle cx="12" cy="12" r="9"/><path d="M12 11v5.5"/><path d="M12 7.6v.9"/></svg>';}
  function area(f){var m=f.imageMediaMetadata; return (m&&m.width&&m.height)? (m.width*m.height):0;}
  function loadSubjects(){
    var p=new URLSearchParams({q:"'"+FOLDER_ID+"' in parents and name='subjects.json' and trashed=false",
      key:API_KEY,fields:"files(id)",supportsAllDrives:"true",includeItemsFromAllDrives:"true"});
    return fetch("https://www.googleapis.com/drive/v3/files?"+p.toString()).then(function(r){return r.json();})
      .then(function(d){ if(d.files&&d.files[0]){
        return fetch("https://www.googleapis.com/drive/v3/files/"+d.files[0].id+"?alt=media&key="+API_KEY)
          .then(function(r){return r.json();}).then(function(j){ SUBJECTS=j||{}; HAYV++; }); } })
      .then(renderSubjectChips).catch(function(){});
  }
  /* crops.json (display crop + true aspect), sizes.json (XS/S/M/L/XL), meta.json
     (dimensions/medium/year) — all fetched by name from the same folder, all optional.
     A missing file just means that feature stays off. */
  function loadOverlay(name, done){
    var p=new URLSearchParams({q:"'"+FOLDER_ID+"' in parents and name='"+name+"' and trashed=false",
      key:API_KEY,fields:"files(id)",supportsAllDrives:"true",includeItemsFromAllDrives:"true"});
    return fetch("https://www.googleapis.com/drive/v3/files?"+p.toString()).then(function(r){return r.json();})
      .then(function(d){ if(d.files&&d.files[0]){
        return fetch("https://www.googleapis.com/drive/v3/files/"+d.files[0].id+"?alt=media&key="+API_KEY)
          .then(function(r){return r.json();}).then(function(j){ done(j||{}); }); } })
      .catch(function(){});
  }
  function regrid(){ ITEMCACHE={}; ITEMN=0; if(wrap&&view&&view.length) redistribute(); }   /* overlays arrived: cached tiles are stale */
  function loadCrops(){ return loadOverlay("crops.json", function(j){ CROPS=j; regrid(); }); }
  function loadSizes(){ return loadOverlay("sizes.json", function(j){ SIZES=j; renderSizeChips(); regrid(); }); }
  function loadMeta(){ return loadOverlay("meta.json", function(j){ META=j; HAYV++; }); }
  var NB=null;  /* neighbors.json overlay: filename -> [visually nearest filenames], from CLIP embeddings */
  function loadNeighbors(){ return loadOverlay("neighbors.json", function(j){
    if(j&&j.names&&j.nb){ NB={};
      for(var i=0;i<j.names.length;i++){ NB[j.names[i]]=j.nb[i]; } NB._names=j.names; } }); }
  /* meta.json = legend + integer indices (1.6MB plain -> 192KB); unpack per row */
  function metaOf(f){
    if(!META||!META.f) return null;
    var row=META.f[f.name]; if(!row) return null;
    var out={}, fields=META.fields||[];
    for(var i=0;i<fields.length;i++){
      var k=fields[i];
      if(k==="x"){ if(row[i]) out.x=row[i]; continue; }
      var legend=META.v&&META.v[k];
      if(legend && typeof row[i]==="number") out[k]=legend[row[i]]||"";
    }
    return out;
  }
  /* Ratio finder — compacted to fit the 50 KB custom_liquid ceiling.
     Readable source: archive_ratio_source.js */
function arOf(t){var a=CROPS[t.name];if(a&&a.ar)return 1/a.ar;if(a&&a.box){var r=a.box[2]-a.box[0],i=a.box[3]-a.box[1];if(r>0&&i>0)return r/i}var e=t.imageMediaMetadata;if(!(e&&e.width&&e.height))return null;return(e.rotation===1||e.rotation===3)?e.height/e.width:e.width/e.height}function ratioOff(t){if(!RON)return null;var a=arOf(t);if(!a)return null;var r=Math.abs(Math.log(a/RTARGET));return REITHER&&(r=Math.min(r,Math.abs(Math.log(a*RTARGET)))),Math.exp(r)-1}function trimIn(t){return null!=t&&RH?t/(1+t)*Math.min(RH,RTARGET*RH):null}function fmtPct(t){return null==t?"":(t<.1?(100*t).toFixed(1):Math.round(100*t))+"%"}function fmtRatio(t){return t>=1?t.toFixed(2)+" : 1":"1 : "+(1/t).toFixed(2)}function rSlider(){return $("#av-rslide")}function paintRatio(){var t=$("#av-ratio");if(t){t.classList.toggle("off",!RON),$("#av-rnum").textContent=fmtRatio(RTARGET);var a=$("#av-rshape").firstChild;if(a.style.width=(RTARGET>=1?28:Math.max(5,Math.round(28*RTARGET)))+"px",a.style.height=(RTARGET>=1?Math.max(5,Math.round(28/RTARGET)):28)+"px",RH){var r=$("#av-rw"),i=$("#av-rh");var _typing=document.activeElement===r||document.activeElement===i;_typing||(r.value=Math.round(RTARGET*RH*10)/10,i.value=Math.round(10*RH)/10)}$("#av-reither").classList.toggle("on",REITHER)}}var rTimer=null,rLast=0,rCost=80;function rQueue(){rTimer||(rTimer=setTimeout(function(){rTimer=null;var t=Date.now();manual=!0,locked=!0,renderFromTop(),rCost=Math.min(400,Math.max(80,1.2*(Date.now()-t))),rLast=Date.now()},Math.max(0,rCost-(Date.now()-rLast))))}function setRatio(t,a){RTARGET=Math.min(4,Math.max(.25,t)),RON=!0,a||RH||(RH=null),"ratio"!==sortEl.value&&(sortEl.value="ratio"),rSlider().value=(Math.log(RTARGET)/Math.LN2).toFixed(4),paintRatio(),rQueue()}function ratioOff_(){RON=!1,RH=null,$("#av-rw").value="",$("#av-rh").value="","ratio"===sortEl.value&&(sortEl.value="num"),paintRatio(),rQueue()}function buildTicks(){var t=$("#av-rticks");t&&(t.innerHTML=RTICKS.map(function(t){return'<span class="av-rtick" data-v="'+t[1]+'" style="left:'+(Math.log(t[1])/Math.LN2+2)/4*100+'%">'+t[0]+"</span>"}).join(""),t.querySelectorAll(".av-rtick").forEach(function(t){t.onclick=function(){RH=null,setRatio(parseFloat(t.getAttribute("data-v")))}}))}function wireRatio(){buildTicks();var t=rSlider();t.addEventListener("input",function(){RTARGET=Math.pow(2,parseFloat(t.value)),RON=!0,"ratio"!==sortEl.value&&(sortEl.value="ratio"),paintRatio(),rQueue()}),["av-rw","av-rh"].forEach(function(t){$("#"+t).addEventListener("input",function(){var t=parseFloat($("#av-rw").value),a=parseFloat($("#av-rh").value);t>0&&a>0&&(RH=a,setRatio(t/a,!0))})}),$("#av-reither").onclick=function(){REITHER=!REITHER,paintRatio(),RON&&rQueue()},$("#av-roff").onclick=ratioOff_,paintRatio()}function ratioNote(){if(!RON||!view||!view.length)return"";var t=RBEST;if(!t)for(var a=0;a<view.length;a++){var r=ratioOff(view[a]);null!=r&&(null==t||r<t.o)&&(t={o:r,f:view[a]})}if(!t)return"";var i=trimIn(t.o);return" · closest "+titleOf(t.f)+", "+fmtPct(t.o)+" off"+(null!=i?" ("+(i<1?i.toFixed(2):i.toFixed(1))+" in trimmed)":"")}

  function renderSizeChips(){
    var order=["XS","S","M","L","XL"], label={XS:"XS",S:"Small",M:"Medium",L:"Large",XL:"X-Large"}, counts={}, k;
    for(k in SIZES){ counts[SIZES[k]]=(counts[SIZES[k]]||0)+1; }
    var present=order.filter(function(s){return counts[s];});
    if(!present.length){ sizeEl.style.display="none"; return; }
    sizeEl.style.display="flex";
    var html='<span class="av-sizelabel">Size</span><button class="av-chip'+(activeSize==null?" on":"")+'" data-z="">All</button>';
    present.forEach(function(s){ html+='<button class="av-chip'+(activeSize===s?" on":"")+'" data-z="'+s+'">'+label[s]+' <span style="opacity:.55">'+counts[s]+'</span></button>'; });
    sizeEl.innerHTML=html;
    sizeEl.querySelectorAll(".av-chip").forEach(function(b){ b.onclick=function(){
      activeSize=b.getAttribute("data-z")||null; renderSizeChips(); onManual(true); }; });
  }
  function renderSubjectChips(){
    var counts={}, k;
    for(k in SUBJECTS){ if(k.charAt(0)==="_") continue; (SUBJECTS[k]||[]).forEach(function(c){counts[c]=(counts[c]||0)+1;}); }
    /* categories come straight from subjects.json (discover_categories) — parents + expandable children */
    var parents=(SUBJECTS._parents||[]).filter(function(c){return counts[c];});
    var children=SUBJECTS._children||{};
    if(!parents.length){ subjEl.style.display="none"; return; }
    subjEl.style.display="flex";
    var html='<button class="av-chip'+(activeSubject==null?" on":"")+'" data-s="">All</button>';
    parents.forEach(function(p){
      var kids=(children[p]||[]).filter(function(c){return counts[c];});
      var on=(activeSubject===p)||(kids.indexOf(activeSubject)>=0);
      html+='<button class="av-chip'+(on?" on":"")+'" data-s="'+escapeHtml(p)+'">'+escapeHtml(p)+' <span style="opacity:.55">'+counts[p]+'</span>'
        +(kids.length?' <span class="av-caret" data-exp="'+escapeHtml(p)+'">'+(expandedParent===p?"&#9652;":"&#9662;")+'</span>':'')+'</button>';
      if(expandedParent===p){ kids.forEach(function(c){
        html+='<button class="av-chip av-sub'+(activeSubject===c?" on":"")+'" data-s="'+escapeHtml(c)+'">'+escapeHtml(c)+' <span style="opacity:.55">'+counts[c]+'</span></button>'; }); }
    });
    subjEl.innerHTML=html;
    subjEl.querySelectorAll(".av-chip").forEach(function(b){ b.onclick=function(e){
      var caret=e.target.closest(".av-caret");
      if(caret){ e.stopPropagation(); var p=caret.getAttribute("data-exp"); expandedParent=(expandedParent===p?null:p); renderSubjectChips(); return; }
      activeSubject=b.getAttribute("data-s")||null; renderSubjectChips(); onManual(true);
    }; });
  }
  /* ---- Plain-English search: match number, categories (subjects.json), medium/support/
     year/notes (meta.json), with a synonym layer for words people actually type.
     Haystacks are cached per file and rebuilt when an overlay arrives (HAYV bump). ---- */
  var HAYV=0;
  var SYN={plank:"wood",planks:"wood",lumber:"wood",timber:"wood",log:"wood",logs:"wood",bark:"wood",
    forest:"tree",woods:"tree",lake:"water",river:"water",creek:"water",stream:"water",
    flower:"botanical",flowers:"botanical",plant:"botanical",plants:"botanical",leaf:"botanical",leaves:"botanical",
    ship:"boat",sail:"boat",person:"faces",people:"faces",bull:"cows",calf:"cows",
    moon:"sky",star:"sky",stars:"sky",cloud:"sky",clouds:"sky",night:"sky",sunrise:"sunset",
    flame:"fire",flames:"fire",burn:"fire",love:"hearts",writing:"lettering",typography:"lettering",
    word:"lettering",words:"lettering",dog:"animals",cat:"animals",bird:"animals",fish:"animals",bear:"animals"};
  function hayOf(f){
    if(f._hayv===HAYV && f._hay!=null) return f._hay;
    var n=numOf(f);
    var cats=(n!=null&&SUBJECTS)?(SUBJECTS[keyOf(n)]||[]):[];
    var m=metaOf(f)||{};
    f._hay=((f.name||"")+" "+cats.join(" ")+" "+(m.m||"")+" "+(m.s||"")+" "+(m.y||"")+" "+(m.x||"")).toLowerCase();
    f._hayv=HAYV; return f._hay;
  }
  function qMatch(f,toks,all){
    var hay = f._group ? (f._group.label.toLowerCase()+" "+f._group.files.map(hayOf).join(" ")) : hayOf(f);
    var hit=function(t){ return hay.indexOf(t)>=0 || (SYN[t]&&hay.indexOf(SYN[t])>=0); };
    return all ? toks.every(hit) : toks.some(hit);
  }
  function buildView(){
    var arr=[], zg={}, zo=[];
    allFiles.forEach(function(f){
      if(f._zine){ if(!zg[f._zine]){ zg[f._zine]=[]; zo.push(f._zine); } zg[f._zine].push(f); }
      else { f._group=null; f._gnum=null; arr.push(f); } });
    zo.forEach(function(zn){ arr.push(makeZine(zn, zg[zn])); });
    var q=qEl.value.trim().toLowerCase();
    if(q){
      var toks=q.split(/\s+/).filter(Boolean);
      var and=arr.filter(function(f){ return qMatch(f,toks,true); });
      /* all words must hit; if that finds nothing, fall back to any-word */
      arr = and.length ? and : (toks.length>1 ? arr.filter(function(f){ return qMatch(f,toks,false); }) : and);
    }
    if(activeSubject){ arr=arr.filter(function(f){ var n=numOf(f); if(n==null) return false;
      var key=("000000"+n).slice(-6); return SUBJECTS[key] && SUBJECTS[key].indexOf(activeSubject)>=0; }); }
    if(activeSize){ arr=arr.filter(function(f){ return SIZES[f.name]===activeSize; }); }
    var v=sortEl.value;
    if(v==="ratio"&&!RON) v="num";
    if(v==="ratio"){   /* score once per file, then sort the scores: calling ratioOff
                          from the comparator made a drag ~170k log-calls deep */
      var k=new Array(arr.length), bst=null;
      for(var i=0;i<arr.length;i++){ var o=ratioOff(arr[i]);
        k[i]={f:arr[i],o:o,n:numOf(arr[i])||0};
        if(o!=null&&(bst==null||o<bst.o)) bst=k[i]; }
      k.sort(function(a,b){ return a.o==null? (b.o==null? b.n-a.n : 1)
                                 : (b.o==null? -1 : a.o-b.o); });
      RBEST=bst;
      for(var j=0;j<k.length;j++) k[j]=k[j].f;
      return k;
    }
    RBEST=null;
    arr.sort(function(a,b){
      var na=numOf(a), nb=numOf(b);
      if(v==="numasc") return (na==null?9e9:na)-(nb==null?9e9:nb);
      if(v==="num")    return (nb==null?-1:nb)-(na==null?-1:na);
      if(v==="old") return (a.createdTime||"").localeCompare(b.createdTime||"");
      if(v==="res") return area(b)-area(a);
      return (b.createdTime||"").localeCompare(a.createdTime||"");  /* new */
    });
    return arr;
  }
  function makeItem(f){
    var item=document.createElement("div"); item.className="av-item"; item._f=f;
    if(SIZES[f.name]==="XS" && activeSize!=="XS") item.className+=" av-xs";   /* XS cards render smaller (except when the grid is already all-XS) */
    var cr=CROPS[f.name];
    if(cr && cr.box){  /* display-crop: show only the keep-rectangle, trimming the white scanner-bed margin (source file untouched) */
      var kw=cr.box[2]-cr.box[0], kh=cr.box[3]-cr.box[1];
      var ci=document.createElement("div"); ci.className="av-cropimg";
      ci.style.paddingBottom=((cr.ar||(kh/kw))*100)+"%";
      ci.style.backgroundImage="url('"+thumb(f.id)+"')";
      ci.style.backgroundSize=(100/kw)+"% "+(100/kh)+"%";
      ci.style.backgroundPosition=(kw<1?(cr.box[0]/(1-kw)*100):0)+"% "+(kh<1?(cr.box[1]/(1-kh)*100):0)+"%";
      item.appendChild(ci);
      var pr=new Image(); pr.onerror=function(){ if(item.parentNode) item.parentNode.removeChild(item); }; pr.src=thumb(f.id);
    } else {
      var im=document.createElement("img"); im.loading="lazy"; im.src=thumb(f.id); im.alt="";
      var _a=arOf(f); if(_a) im.style.aspectRatio="auto "+_a;   /* reserve height before load; "auto" lets the loaded pixels' true ratio win over metadata — a 0-height unloaded tile skews pairs and the masonry */
      im.onerror=function(){ if(item.parentNode) item.parentNode.removeChild(item); };
      item.appendChild(im);
    }
    item.onclick=function(e){ if(e.target.closest(".av-ic"))return; openLightbox(f); };
    if(f._group){ var zb=document.createElement("div"); zb.className="av-zbadge";
      zb.innerHTML=folderSvg()+'<span>Zine &middot; '+f._group.files.length+' pages</span>'; item.appendChild(zb); }
    var cap=document.createElement("div"); cap.className="av-cap";
    cap.textContent=f._group?(f._group.label+(f._gnum!=null?" — #"+f._gnum:"")):titleOf(f); item.appendChild(cap);
    var ov=document.createElement("div"); ov.className="av-ov";
    var b1=document.createElement("button"); b1.className="av-ic"; b1.title="Details"; b1.setAttribute("aria-label","Details");
    b1.innerHTML=infoIcon();
    b1.onclick=function(e){e.stopPropagation(); openLightbox(f);}; ov.appendChild(b1);
    item.appendChild(ov); return item;
  }
  /* ---- Reading-order masonry: natural heights (size shows), strict number order, responsive cols ---- */
  var cols=[], NCOL=0, colCur=0;
  function colCount(){ /* dynamic: ~320px per column, 2 on mobile up to 6 on ultra-wide */
    if(window.innerWidth<760) return 2;
    var cw=(main&&main.clientWidth)||window.innerWidth;
    return Math.max(3, Math.min(6, Math.round(cw/320)));
  }
  function buildCols(){
    NCOL=colCount(); wrap.innerHTML=""; cols=[]; colCur=0;
    for(var i=0;i<NCOL;i++){ var d=document.createElement("div"); d.className="av-col"; wrap.appendChild(d); cols.push(d); }
  }
  function resetLayout(){ cols=[]; NCOL=0; colCur=0; }
  var pairLeader={}, pairUsed={};
  function computePairs(){   /* pair every XS with the next SHAPE-COMPATIBLE XS ahead (pull it up) so lone XS don't leave gaps */
    pairLeader={}; pairUsed={};
    if(activeSize==="XS") return;   /* all-XS view: no pairing, uniform singles */
    for(var i=0;i<view.length;i++){
      if(pairUsed[i] || SIZES[(view[i]||{}).name]!=="XS") continue;
      var ai=arOf(view[i]);
      for(var j=i+1;j<view.length;j++){
        if(pairUsed[j] || SIZES[(view[j]||{}).name]!=="XS") continue;
        /* a pair stretches both tiles to one row height, so only matching shapes may pair:
           a ~4x4 post-it beside a 5x8.5 card leaves dead space under the shorter image.
           XS stopped being one shape when multi-card intake began cutting square post-its. */
        var aj=arOf(view[j]);
        if(ai&&aj&&Math.abs(Math.log(ai/aj))<=0.22){ pairLeader[i]=j; pairUsed[j]=1; break; }
      }
    }
  }
  /* element cache: re-sorts and refilters REORDER existing tiles instead of rebuilding
     them, so images never flash back in — this is what makes the ratio slider smooth */
  var ITEMCACHE={}, ITEMN=0;
  function itemFor(f){
    if(f._group) return makeItem(f);              /* zine covers carry per-view state */
    var el=ITEMCACHE[f.id];
    if(!el){ if(ITEMN>4000){ ITEMCACHE={}; ITEMN=0; }
      el=makeItem(f); ITEMCACHE[f.id]=el; ITEMN++; }
    el.className="av-item"+((SIZES[f.name]==="XS"&&activeSize!=="XS")?" av-xs":"");
    return el;
  }
  function makePair(a,b){
    var d=document.createElement("div"); d.className="av-pair";
    var ia=itemFor(a), ib=itemFor(b);
    ia.classList.remove("av-xs"); ib.classList.remove("av-xs");   /* already half-width inside the pair */
    d.appendChild(ia); d.appendChild(ib); return d;
  }
  function placeRange(i, target){   /* round-robin into columns; an XS 'leader' renders its pulled-up XS partner beside it */
    while(i<target){
      if(pairUsed[i]){ i++; continue; }   /* already rendered as an earlier leader's partner */
      var slot = (pairLeader[i]!=null) ? makePair(view[i], view[pairLeader[i]]) : itemFor(view[i]);
      cols[colCur % NCOL].appendChild(slot); colCur++;
      i++;
    }
    return i;
  }
  function appendBatch(){
    if(rendered>=view.length) return;
    if(!cols.length) buildCols();
    rendered=placeRange(rendered, Math.min(rendered+BATCH, view.length));
    currentImages=view;
  }
  function redistribute(){   /* rebuild columns + re-place all rendered items (resize / refresh) */
    if(!wrap) return;
    var r=rendered; buildCols(); rendered=placeRange(0, Math.min(r, view.length));
    currentImages=view;
  }
  var _jrz=null;
  window.addEventListener("resize", function(){ if(!wrap || colCount()===NCOL) return; clearTimeout(_jrz); _jrz=setTimeout(redistribute,150); });
  window.addEventListener("load", function(){ if(wrap && colCount()!==NCOL) redistribute(); });   /* correct count once width is final */
  function viewportShort(){
    return document.documentElement.scrollHeight <= window.innerHeight + 120;
  }
  function fillViewport(){
    var guard=0;
    while(rendered<view.length && viewportShort() && guard<3){ appendBatch(); guard++; }
  }
  function renderFromTop(){
    view=buildView(); computePairs();
    main.innerHTML=""; wrap=document.createElement("div"); wrap.className="av-masonry"; main.appendChild(wrap);
    rendered=0; resetLayout();
    if(!view.length){ main.innerHTML='<div class="av-state"><h3>Nothing here</h3>No drawings match.</div>'; updateCount(0); return; }
    appendBatch(); fillViewport(); updateCount(view.length);
  }
  function lockAndRender(){ locked=true; renderFromTop(); }
  function liveRefresh(){
    renderStats();
    if(locked||manual) return;
    if(rafPending) return; rafPending=true;
    requestAnimationFrame(function(){
      rafPending=false;
      if(locked||manual) return;
      view=buildView(); computePairs();
      var keep=Math.max(rendered, BATCH);
      main.innerHTML=""; wrap=document.createElement("div"); wrap.className="av-masonry"; main.appendChild(wrap);
      rendered=Math.min(keep, view.length); resetLayout(); redistribute();
      currentImages=view;
      updateCount(view.length);
    });
  }
  function feedNearBottom(){   /* keep appending while the bottom is close — a scroll that
                                  LANDS at the bottom and stops fires no more events */
    var guard=0;
    while(rendered<view.length && guard<3 &&
          window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 1400){
      appendBatch(); guard++;
    }
  }
  function onScroll(){
    if(!locked){ lockAndRender(); return; }
    if(rendered>=view.length) return;
    feedNearBottom();
  }
  window.addEventListener("scroll", onScroll, {passive:true});
  function updateCount(c){ countEl.textContent=c+" shown"; }   /* the closest-match note wrapped the header mid-drag; the sort order already says it */
  function fmtNum(n){ try{return n.toLocaleString();}catch(e){return ""+n;} }
  var SERIES_START = new Date(2021,0,1);   /* SXF numbering began 2021 */
  function renderStats(){
    var maxNum=null;
    for(var i=0;i<allFiles.length;i++){
      var n=numOf(allFiles[i]); if(n==null) continue;
      if(maxNum==null||n>maxNum) maxNum=n;
    }
    if(maxNum==null){ statsEl.style.display="none"; statsEl.innerHTML=""; return; }
    var days = Math.max(1,(new Date()-SERIES_START)/86400000);
    var perYear = Math.round(maxNum/(days/365.25));
    var perMonth = Math.round(maxNum/(days/30.44));
    var perDay = maxNum/days;
    function st(b,s){ return '<div class="av-stat"><b>'+b+'</b><span>'+s+'</span></div>'; }
    var html = st(fmtNum(maxNum),"Total Drawings");
    html += st("2021","Numbered Since");
    html += st("~"+fmtNum(perYear),"A Year");
    html += st("~"+fmtNum(perMonth),"A Month");
    html += st("~"+(perDay>=1?Math.round(perDay):perDay.toFixed(1)),"A Day");
    statsEl.innerHTML=html; statsEl.style.display="flex";
  }
  function triggerDownload(f){ var a=document.createElement("a"); a.href=dl(f.id); a.download=f.name||""; document.body.appendChild(a); a.click(); a.remove(); toast("Download started"); }
  var zineView=null;   /* set = the lightbox pages through this zine */
  function openLightbox(f){
    if(f._group){ zineView=f._group; currentImages=f._group.files; lbIndex=0;
      showLightbox(currentImages[0]); $("#av-lb").classList.add("open"); lbOpened(); $("#av-lb").scrollTop=0; return; }
    zineView=null; currentImages=view;
    lbIndex=currentImages.findIndex(function(x){return x.id===f.id;}); showLightbox(f); $("#av-lb").classList.add("open"); lbOpened();
    $("#av-lb").scrollTop=0; }   /* scrollTop is a no-op while display:none — reset AFTER opening,
                                    or the lightbox reopens wherever it was last closed */
  /* size / medium / year pills; category names = the same subjects.json vocabulary as the chips */
  function renderMeta(f){
    var el=$("#av-lb-meta"); if(!el) return;
    var m=metaOf(f)||{}, bits=[];
    function pill(label,val,cls){ if(!val) return;
      bits.push('<span'+(cls?' class="'+cls+'"':'')+'><b>'+label+'</b>'+escapeHtml(val)+'</span>'); }
    pill("Size", m.d);
    pill("Medium", m.m);
    /* The medium reads "archival ink on archival kraft paper", so a separate Paper pill repeats
       the support word for word. Only show it when the medium does not already name it. */
    if(m.s && (!m.m || m.m.toLowerCase().indexOf(m.s.toLowerCase())<0)) pill("Paper", m.s);
    pill("Year", m.y);
    var _ar=arOf(f); if(_ar) pill("Ratio", fmtRatio(_ar));
    if(RON){ var _o=ratioOff(f); if(_o!=null) pill("Vs "+fmtRatio(RTARGET), fmtPct(_o)+" off"); }
    var n=numOf(f);
    var cats = (n!=null && typeof SUBJECTS!=="undefined" && SUBJECTS) ? SUBJECTS[("000000"+n).slice(-6)] : null;
    if(cats && cats.length){
      var parents = (SUBJECTS._parents)||[];
      /* broad cats first, CAPPED at 5 — a wall of chips buries size+medium */
      var top=cats.filter(function(c){return parents.indexOf(c)>=0;});
      var sub=cats.filter(function(c){return parents.indexOf(c)<0;});
      top.slice(0,3).concat(sub.slice(0,2)).forEach(function(c){ pill("", c, "av-lb-cat"); });
    }
    if(m.x) bits.push('<span style="white-space:normal;max-width:520px">'+escapeHtml(m.x)+'</span>');
    el.innerHTML=bits.join("");
    el.style.display=bits.length?"flex":"none";
  }
  /* ---- Similar drawings: shared subjects (from subjects.json) weighted highest,
     then same size class and closest aspect ratio. All client-side, zero new requests. ---- */
  function keyOf(n){ return ("000000"+n).slice(-6); }
  var NAMEIDX=null, NAMEIDXN=0;
  function nameIdx(){
    if(!NAMEIDX||NAMEIDXN!==allFiles.length){
      NAMEIDX={}; for(var i=0;i<allFiles.length;i++){ NAMEIDX[allFiles[i].name]=allFiles[i]; }
      NAMEIDXN=allFiles.length;
    }
    return NAMEIDX;
  }
  function similarTo(f, max){
    max = max||12;
    var n=numOf(f), out=[], seenN={};
    /* visual neighbors (CLIP) lead — actual look-alikes, immune to mis-tags */
    if(NB&&NB[f.name]&&NB._names){
      var ix=nameIdx(), list=NB[f.name];
      for(var v=0;v<list.length && out.length<max;v++){
        var c0=ix[NB._names[list[v]]];
        if(!c0||c0._zine) continue;
        var cn0=numOf(c0); if(cn0==null||cn0===n||seenN[cn0]) continue;
        seenN[cn0]=1; out.push(c0);
      }
    }
    if(out.length>=max) return out;
    /* tag/paper/sequence scorer ranks the rest of the archive behind the visual set */
    var myCats = (n!=null && SUBJECTS) ? (SUBJECTS[keyOf(n)]||[]) : [];
    var parents = (SUBJECTS&&SUBJECTS._parents)||[];
    var myAr = arOf(f)||1, mySize = SIZES[f.name];
    var myMed = (metaOf(f)||{}).m||"";
    var scored=[];
    for(var i=0;i<allFiles.length;i++){
      var c=allFiles[i];
      if(c.id===f.id || c._zine) continue;          /* zine pages stay inside their zines */
      var cn=numOf(c); if(cn==null||cn===n||seenN[cn]) continue;
      var s=0, cats=SUBJECTS[keyOf(cn)]||[];
      /* specific child categories (Waves, Willows) say far more than broad parents (Water) */
      for(var j=0;j<cats.length;j++){
        if(myCats.indexOf(cats[j])>=0) s += (parents.indexOf(cats[j])>=0 ? 1 : 3);
      }
      if(mySize && SIZES[c.name]===mySize) s+=1;
      if(myMed && (metaOf(c)||{}).m===myMed) s+=1.5;   /* same paper: white pairs with white, kraft with kraft */
      if(n!=null) s += 1.5*Math.exp(-Math.abs(cn-n)/60);  /* neighbors in the sequence = same session, same vibe */
      var car=arOf(c); if(car) s += 1/(1+Math.abs(Math.log(car/myAr))*2);
      if(s>1) scored.push({s:s, f:c, n:cn});
    }
    scored.sort(function(a,b){ return b.s-a.s || Math.abs(a.n-(n||0))-Math.abs(b.n-(n||0)); });
    for(var k=0;k<scored.length && out.length<max;k++){
      if(seenN[scored[k].n]) continue;              /* collision numbers: each number once */
      seenN[scored[k].n]=1; out.push(scored[k].f);
    }
    return out;
  }
  var SIM={list:[],shown:0};
  function simTile(sf){
    var d=document.createElement("div"); d.className="av-sim"; d.title=titleOf(sf);
    var cr=CROPS[sf.name];
    if(cr&&cr.box){   /* same display-crop as the grid tiles — no scanner-bed white */
      var kw=cr.box[2]-cr.box[0], kh=cr.box[3]-cr.box[1];
      var ci=document.createElement("div"); ci.className="av-cropimg";
      ci.style.paddingBottom=((cr.ar||(kh/kw))*100)+"%";
      ci.style.backgroundImage="url('"+thumb(sf.id)+"')";
      ci.style.backgroundSize=(100/kw)+"% "+(100/kh)+"%";
      ci.style.backgroundPosition=(kw<1?(cr.box[0]/(1-kw)*100):0)+"% "+(kh<1?(cr.box[1]/(1-kh)*100):0)+"%";
      d.appendChild(ci);
    } else {
      var im=document.createElement("img"); im.loading="lazy"; im.src=thumb(sf.id); im.alt=titleOf(sf);
      im.onerror=function(){ if(d.parentNode) d.parentNode.removeChild(d); };
      d.appendChild(im);
    }
    d.onclick=function(){
      zineView=null; currentImages=view;
      var ix=view.findIndex(function(x){return x.id===sf.id;});
      if(ix>=0) lbIndex=ix;
      showLightbox(sf);
    };
    return d;
  }
  function appendSims(){
    if(!SIM.cols||!SIM.cols.length) return;
    var end=Math.min(SIM.shown+12, SIM.list.length);
    for(var i=SIM.shown;i<end;i++) SIM.cols[i%SIM.cols.length].appendChild(simTile(SIM.list[i]));
    SIM.shown=end;
  }
  function renderSimilar(f){
    var box=$("#av-lb-similar"), grid=$("#av-lb-simgrid"); if(!box||!grid) return;
    grid.innerHTML=""; SIM.list=[]; SIM.shown=0; SIM.cols=[];
    if(f._group){ box.style.display="none"; return; }
    SIM.list=similarTo(f, 200);   /* deep ranked list; the lightbox scroll pages through it */
    if(!SIM.list.length){ box.style.display="none"; return; }
    box.style.display="block";
    var ncol=Math.max(2, Math.min(5, Math.floor((grid.clientWidth||600)/170)));
    for(var c=0;c<ncol;c++){ var col=document.createElement("div"); col.className="av-simcol";
      grid.appendChild(col); SIM.cols.push(col); }
    appendSims();
  }
  /* similars page in as the detail view scrolls — same feel as the main grid */
  $("#av-lb").addEventListener("scroll", function(){
    var lb=$("#av-lb");
    if(!lb.classList.contains("open")||SIM.shown>=SIM.list.length) return;
    if(lb.scrollTop+lb.clientHeight >= lb.scrollHeight-900) appendSims();
  }, {passive:true});
  /* ---- Stage + museum zoom. Click the drawing to enter the viewer: scroll wheel
     zooms toward the cursor, drag pans, pinch works on touch, double-click resets,
     a click at fit size leaves. Continuous zoom, capped at the 1800px source.
     Right-click always saves the untouched original — display-only, reversible. ---- */
  var LBZOOM=false, LBF=null;
  function hiWidth(f){
    /* the sharpest rendition the DEVICE will actually decode: iOS silently
       subsamples JPEGs past ~16MP (a w3600 of a tall scan came back half-res),
       so the request is sized per drawing to stay inside the decode budget */
    var m=f.imageMediaMetadata||{};
    if(!m.width||!m.height) return 1800;
    var budget=isMobile?15e6:48e6;
    var cap=Math.floor(Math.sqrt(budget*m.width/m.height));
    return Math.min(m.width, Math.max(1800, cap));
  }
  function hiSrc(f){ var w=hiWidth(f);
    return w>1800 ? "https://lh3.googleusercontent.com/d/"+f.id+"=w"+w : big(f.id); }
  function artBox(f){   /* how the artwork displays: aspect (h/w), native width, builder */
    var cr=CROPS[f.name];
    var natFull=hiWidth(f);   /* the zoom ceiling = the pixels actually loaded */
    if(cr&&cr.box){
      var kw=cr.box[2]-cr.box[0], kh=cr.box[3]-cr.box[1];
      var AR=cr.ar||(kh/kw);
      return {AR:AR, natW:natFull*kw, make:function(W,H){
        var d=document.createElement("div"); d.className="av-lb-cropwrap";
        d.style.width=Math.round(W)+"px"; d.style.height=Math.round(H)+"px";
        var im=document.createElement("img"); im.src=big(f.id); im.alt="";
        im.style.width=Math.round(W/kw)+"px"; im.style.height=Math.round(H/kh)+"px";
        im.style.marginLeft=Math.round(-cr.box[0]*W/kw)+"px"; im.style.marginTop=Math.round(-cr.box[1]*H/kh)+"px";
        d.appendChild(im); return d; }};
    }
    var ar=arOf(f), AR2=ar?1/ar:1.4;
    return {AR:AR2, natW:natFull, make:function(W,H){
      var im=document.createElement("img"); im.src=big(f.id); im.alt="";
      im.style.maxWidth="none"; im.style.maxHeight="none";
      im.style.width=Math.round(W)+"px"; im.style.height=Math.round(H)+"px";
      return im; }};
  }
  function renderZoomViewer(f, fx, fy){
    var stage=$("#av-lb-stage"); if(!stage) return;
    var box=artBox(f);
    var vw=Math.max(window.innerWidth,320), vh=Math.max(window.innerHeight,480);
    var Wv=Math.round((isMobile?0.96:0.92)*vw), Hv=Math.round((isMobile?0.72:0.78)*vh);
    var W=Math.min(Wv, Hv/box.AR), H=W*box.AR;   /* content at fit size */
    var content=box.make(W,H);
    content.style.transformOrigin="0 0"; content.style.willChange="transform";
    var vp=document.createElement("div"); vp.className="av-zv";
    vp.style.width=Wv+"px"; vp.style.height=Hv+"px";
    vp.appendChild(content);
    var hint=document.createElement("div"); hint.className="av-zv-hint";
    hint.textContent="scroll to zoom · drag to pan · double-click to reset";
    vp.appendChild(hint);
    stage.innerHTML=""; stage.appendChild(vp);
    /* swap in the high-res rendition once it arrives — the styled dimensions
       don't change, the pixels just sharpen in place */
    (function(){
      var im=content.tagName==="IMG"?content:content.querySelector("img");
      if(!im) return;
      var probe=new Image();
      probe.onload=function(){ if(im.isConnected) im.src=probe.src; };
      probe.src=hiSrc(f);
    })();

    var maxS=Math.max(2.5,(box.natW/W)*1.25), s=1, tx=0, ty=0, clickTimer=null;
    function clamp(){
      tx = (s*W<=Wv) ? (Wv-s*W)/2 : Math.max(Wv-s*W, Math.min(0, tx));
      ty = (s*H<=Hv) ? (Hv-s*H)/2 : Math.max(Hv-s*H, Math.min(0, ty));
    }
    function apply(anim){
      content.style.transition=anim?"transform .28s ease":"none";
      content.style.transform="translate("+tx.toFixed(1)+"px,"+ty.toFixed(1)+"px) scale("+s.toFixed(4)+")";
    }
    function leave(){ clearTimeout(clickTimer); LBZOOM=false; renderStage(f,false); }
    function zoomAt(mx,my,factor,anim){
      var ns=Math.min(maxS, Math.max(1, s*factor));
      if(ns<=1.001 && factor<1 && s<=1.001){ leave(); return; }   /* wheeling out past fit walks away */
      tx = mx-(ns/s)*(mx-tx); ty = my-(ns/s)*(my-ty);
      s=ns; clamp(); apply(anim);
    }
    /* enter zoomed onto the point that was clicked */
    s=Math.min(2.4,maxS);
    tx = Wv/2 - s*(fx!=null?fx:0.5)*W;
    ty = Hv/2 - s*(fy!=null?fy:0.5)*H;
    clamp(); apply(false);

    vp.addEventListener("wheel",function(e){
      e.preventDefault(); e.stopPropagation();
      var r=vp.getBoundingClientRect();
      zoomAt(e.clientX-r.left, e.clientY-r.top, Math.exp(-e.deltaY*0.0016), false);
    },{passive:false});

    var pts={}, drag=null, pinch=null, moved=false;
    vp.addEventListener("pointerdown",function(e){
      if(e.button===2) return;                       /* right-click saves the original */
      pts[e.pointerId]={x:e.clientX,y:e.clientY};
      var ids=Object.keys(pts);
      if(ids.length===1){ drag={x:e.clientX,y:e.clientY,tx:tx,ty:ty}; moved=false; }
      else if(ids.length===2){ drag=null;
        var a=pts[ids[0]], b=pts[ids[1]];
        pinch={d:Math.hypot(a.x-b.x,a.y-b.y)}; }
      try{vp.setPointerCapture(e.pointerId);}catch(_){}
    });
    vp.addEventListener("pointermove",function(e){
      if(!pts[e.pointerId]) return;
      pts[e.pointerId]={x:e.clientX,y:e.clientY};
      var ids=Object.keys(pts);
      if(pinch&&ids.length===2){
        var a=pts[ids[0]], b=pts[ids[1]];
        var d=Math.hypot(a.x-b.x,a.y-b.y);
        if(d>0&&pinch.d>0){ var r=vp.getBoundingClientRect();
          zoomAt((a.x+b.x)/2-r.left,(a.y+b.y)/2-r.top, d/pinch.d, false); }
        pinch.d=d;
      } else if(drag){
        var dx=e.clientX-drag.x, dy=e.clientY-drag.y;
        if(Math.abs(dx)+Math.abs(dy)>4) moved=true;
        tx=drag.tx+dx; ty=drag.ty+dy; clamp(); apply(false);
      }
    });
    function up(e){ delete pts[e.pointerId];
      if(Object.keys(pts).length<2) pinch=null;
      if(!Object.keys(pts).length) drag=null; }
    vp.addEventListener("pointerup",up); vp.addEventListener("pointercancel",up);

    vp.addEventListener("dblclick",function(e){
      e.preventDefault(); e.stopPropagation(); clearTimeout(clickTimer);
      var r=vp.getBoundingClientRect();
      if(s>1.01){ s=1; clamp(); apply(true); }
      else zoomAt(e.clientX-r.left, e.clientY-r.top, 2.5, true);
    });
    vp.addEventListener("click",function(e){
      e.stopPropagation();
      if(moved){ moved=false; return; }
      if(s<=1.001){ clearTimeout(clickTimer); clickTimer=setTimeout(leave,300); }  /* single click at fit leaves (a dblclick cancels it) */
    });
  }
  function renderStage(f, zoom, fx, fy){
    if(zoom){ renderZoomViewer(f, fx, fy); return; }
    var stage=$("#av-lb-stage"); if(!stage) return;
    var box=artBox(f);
    var vw=Math.max(window.innerWidth,320), vh=Math.max(window.innerHeight,480);
    var W=Math.min((isMobile?0.96:0.92)*vw, (isMobile?0.68:0.74)*vh/box.AR);
    var inner=box.make(W, W*box.AR);
    inner.style.cursor="zoom-in"; inner.title="Click to zoom in";
    stage.innerHTML=""; stage.appendChild(inner);
    inner.addEventListener("click",function(e){
      e.stopPropagation();
      var r=inner.getBoundingClientRect();
      LBZOOM=true;
      renderStage(f, true, (e.clientX-r.left)/Math.max(r.width,1), (e.clientY-r.top)/Math.max(r.height,1));
    });
  }
  function showLightbox(f){
    LBZOOM=false; LBF=f;
    renderStage(f, false);
    $("#av-lb").scrollTop=0;
    $("#av-lb-title").textContent = zineView?(zineView.label+" — page "+(lbIndex+1)+" / "+zineView.files.length):titleOf(f);
    renderMeta(f);
    var n=numOf(f);
    var ref = n!=null ? ("000000"+n).slice(-6) : (f.name||"");
    $("#av-lb-email").href = "/products/custom-artwork?ref="+encodeURIComponent(ref);
    var comm=$("#av-lb-commission"); if(comm) comm.href="/products/custom-artwork?ref="+encodeURIComponent(ref);
    renderSimilar(f);
  }
  function step(dir){ if(!currentImages.length) return; lbIndex=(lbIndex+dir+currentImages.length)%currentImages.length; showLightbox(currentImages[lbIndex]); }
  function closeLB(){ $("#av-lb").classList.remove("open"); document.documentElement.style.overflow=""; }
  function lbOpened(){ document.documentElement.style.overflow="hidden"; }   /* page behind must not scroll */
  $("#av-lb-close").onclick=closeLB;
  $("#av-lb-prev").onclick=function(){step(-1);};
  $("#av-lb-next").onclick=function(){step(1);};
  $("#av-lb").onclick=function(e){ if(e.target.id==="av-lb"||e.target.classList.contains("av-lb-scroll")) closeLB(); };
  document.addEventListener("keydown",function(e){ if(!$("#av-lb").classList.contains("open")) return;
    if(e.key==="Escape"){ if(LBZOOM&&LBF){ LBZOOM=false; renderStage(LBF,false); } else closeLB(); }
    if(e.key==="ArrowLeft") step(-1); if(e.key==="ArrowRight") step(1); });
  /* chips scroll you to the drawings (on a phone the grid starts below the fold, so a
     filter tap looked like a no-op); typing in search keeps you at the top of the page */
  function scrollToGrid(){
    var top = main.getBoundingClientRect().top + window.pageYOffset - (($(".av-top")&&$(".av-top").offsetHeight)||0) - 4;
    window.scrollTo(0, Math.max(0, top));
  }
  function onManual(toGrid){ manual=true; locked=true; renderFromTop();
    if(isMobile){ if(toGrid===true) scrollToGrid(); else window.scrollTo(0,0); } }
  qEl.addEventListener("input",function(){ onManual(); });
  /* size chips + ratio finder live behind the Filters toggle; choosing the ratio
     sort opens it so the slider is never invisibly in charge of the order */
  function setFilters(open){ var c=$(".av-controls"), b=$("#av-filters"); if(!c||!b) return;
    c.classList.toggle("open",open); b.classList.toggle("on",open);
    var cr=b.querySelector(".av-fcaret"); if(cr) cr.innerHTML=open?"&#9652;":"&#9662;"; }
  $("#av-filters").onclick=function(){ setFilters(!$(".av-controls").classList.contains("open")); };
  sortEl.addEventListener("change",function(){ if(sortEl.value==="ratio"&&!RON){ RON=true; paintRatio(); }
    if(sortEl.value==="ratio") setFilters(true); onManual(); });
  function collect(id, token, chain){
    chain = chain || [path[path.length-1].name];
    return listCached(id).then(function(r){
      if(token!==loadToken) return;
      if(r.files.length){
        var imgs=r.files.filter(function(f){return IMG(f.mimeType);});
        var zi=zineOf(chain);
        for(var i=0;i<imgs.length;i++){ imgs[i]._zine=zi; allFiles.push(imgs[i]); }
        if(imgs.length) liveRefresh();
      }
      return Promise.all(r.folders.map(function(f){
        if(token!==loadToken) return null;
        return collect(f.id, token, chain.concat(f.name||""));
      }));
    });
  }
  function load(){
    var token=++loadToken;
    renderCrumbs();
    foldersEl.innerHTML="";
    allFiles=[]; view=[]; currentImages=[]; rendered=0; locked=false; manual=false; loadingDone=false; wrap=null;
    statsEl.style.display="none"; statsEl.innerHTML="";
    if(!isMobile) main.scrollTop=0;
    main.innerHTML='<div class="av-state"><div class="av-spinner"></div>Loading the collection...</div>';
    countEl.textContent="";
    var here=path[path.length-1].id;
    listCached(here).then(function(r){ if(token===loadToken) renderFolders(r.folders); });
    collect(here, token).then(function(){
      if(token!==loadToken) return;
      loadingDone=true;
      renderStats();
      if(!manual){ lockAndRender(); }
      if(!view.length && !allFiles.length){ main.innerHTML='<div class="av-state"><h3>Nothing here yet</h3>Drawings filed into this folder in Drive appear automatically.</div>'; }
    }).catch(function(err){
      if(token!==loadToken) return;
      var msg=(""+err); var friendly="Could not load the archive.";
      if(msg.indexOf("403")>=0) friendly="Access denied (403). Make sure 01 SXF NUMBERED SERIES is shared as Anyone with the link can View, and the API key allows the Drive API.";
      else if(msg.indexOf("404")>=0) friendly="Folder not found (404). Check the folder ID.";
      if(!allFiles.length) main.innerHTML='<div class="av-state"><h3>That did not load</h3>'+escapeHtml(friendly)+'</div>';
    });
  }
  /* ---- Demo mode: after 45s idle the archive browses itself IN PLACE — grid tiles
     keep swapping, and it ghost-types real searches / clicks real category chips so
     the controls visibly do their thing. Any real input (isTrusted) simply stops the
     demo and hands the page over exactly as it stands — the controls were live the
     whole time. Synthetic events used by the demo (input/click) are never in the
     exit list, so it cannot wake itself. ---- */
  var AT={on:false,timer:null,idleMs:90000,timers:[],tgt:null,enabled:false};
  /* 2026-10-01: Cole kept losing the drawing he had open to the idle demo, so it is OFF by default.
     The "Autoplay" chip in the top bar turns it on (remembered per browser); ?autoplay=1 forces it on for gallery screens. */
  try{ AT.enabled = /[?&]autoplay=1(&|$)/.test(location.search) || localStorage.getItem("sxf-autoplay")==="1"; }catch(e){}   /* 30s was gallery-kiosk pacing; regular visitors get a quiet minute and a half */
  var DEMO_QUERIES=["pond","beaver","sunset","wood","fire","hearts","trees","boats","eyes","willow","water","cows"];
  function atArm(){ clearTimeout(AT.timer); AT.timer=null; if(!AT.enabled) return; AT.timer=setTimeout(atEnter,AT.idleMs); }
  function setQ(v){ qEl.value=v; qEl.dispatchEvent(new Event("input")); }
  function pick(arr){ return arr&&arr.length ? arr[Math.floor(Math.random()*arr.length)] : null; }
  function ghostMoveTo(el){
    AT.tgt=el||null; if(!el) return;
    var r=el.getBoundingClientRect(), y=r.top+r.height/2;
    /* fixed elements (close, arrows) are always where they are — scrolling never moves
       them, and repositioning the ghost to mid-screen made close-clicks look like the
       next-arrow. Only scroll for targets genuinely outside the viewport. */
    var fixed = getComputedStyle(el).position==="fixed";
    if(!fixed && (r.bottom<60 || r.top>window.innerHeight-60)){
      el.scrollIntoView({block:"center",behavior:"smooth"});
      y=window.innerHeight/2;                       /* where block:center will land it */
    }
    var g=$("#av-ghost");
    g.style.transform="translate("+Math.round(r.left+r.width/2)+"px,"+Math.round(y)+"px)";
  }
  function ghostClick(){
    var g=$("#av-ghost");
    if(AT.tgt){   /* layout may have shifted since the glide began (header collapse,
                     images landing) — snap to where the target is NOW */
      var r=AT.tgt.getBoundingClientRect();
      if(r.width||r.height) g.style.transform="translate("+Math.round(r.left+r.width/2)+"px,"+Math.round(r.top+r.height/2)+"px)";
    }
    g.classList.remove("click"); void g.offsetWidth; g.classList.add("click");
    var t=AT.tgt;
    if(t) AT.timers.push(setTimeout(function(){ if(AT.on&&t) t.click(); },180));  /* ring first, then the click lands */
  }
  function visibleItems(){
    if(!wrap) return [];
    return Array.prototype.filter.call(wrap.querySelectorAll(".av-item"),function(el){
      var r=el.getBoundingClientRect();
      return r.top>130 && r.bottom<window.innerHeight-30 && r.width>60;
    });
  }
  function lbScrollToSimilar(){
    var lb=$("#av-lb"), sim=$("#av-lb-similar");
    if(lb&&sim&&sim.style.display!=="none")
      lb.scrollTo({top:sim.getBoundingClientRect().top+lb.scrollTop-130,behavior:"smooth"});
  }
  /* The idle demo behaves like a person: glide the cursor, click a drawing, read it,
     scroll to its similars, dive deeper, close, search, filter. Every on-screen change
     traces to a visible cursor action. */
  function atScript(){
    if(!AT.on) return;
    var steps=[], r=Math.random();
    function mv(getEl,dwellAfter){   /* brisk between actions; the dwells do the lingering */
      steps.push([550,function(){ ghostMoveTo(getEl()); }]);
      steps.push([700,ghostClick]);
      steps.push([dwellAfter||400,function(){}]);
    }
    function scrollRun(n,px){   /* successive smooth scrolls: show just how deep the archive goes */
      for(var i=0;i<n;i++){
        steps.push([650,function(){ window.scrollBy({top:px,behavior:"smooth"}); }]);
        steps.push([500,feedNearBottom]);   /* landing at the bottom fires no scroll events */
      }
    }
    if(r<0.34){         /* open a drawing -> similars -> dive -> dive -> close */
      steps.push([300,function(){ window.scrollBy({top:420,behavior:"smooth"}); }]);
      mv(function(){ return pick(visibleItems())||(wrap&&wrap.querySelector(".av-item")); },3600);  /* let the drawing itself have its moment */
      steps.push([200,lbScrollToSimilar]);
      steps.push([1900,function(){}]);
      mv(function(){ return pick(Array.prototype.slice.call(document.querySelectorAll(".av-sim")).slice(0,5)); },3000);
      steps.push([200,lbScrollToSimilar]);
      steps.push([1700,function(){}]);
      mv(function(){ return pick(Array.prototype.slice.call(document.querySelectorAll(".av-sim")).slice(0,5)); },3000);
      mv(function(){ return $("#av-lb-close"); },700);
    } else if(r<0.54){  /* search, scroll the results, open one from down there, then head home */
      mv(function(){ return document.querySelector(".av-search"); },200);
      var q=pick(DEMO_QUERIES);
      for(var i=1;i<=q.length;i++)(function(k){ steps.push([140,function(){ setQ(q.slice(0,k)); }]); })(i);
      steps.push([2600,function(){}]);
      scrollRun(2,760);
      mv(function(){ return pick(visibleItems()); },3400);
      steps.push([200,lbScrollToSimilar]);
      steps.push([1700,function(){}]);
      mv(function(){ return pick(Array.prototype.slice.call(document.querySelectorAll(".av-sim")).slice(0,5)); },2800);
      mv(function(){ return $("#av-lb-close"); },600);
      steps.push([200,function(){ window.scrollTo({top:0,behavior:"smooth"}); }]);
      steps.push([1600,function(){ setQ(""); }]);   /* back at the top BEFORE the results reset */
    } else if(r<0.60){  /* category chip, scroll the results, back to All */
      mv(function(){ var c=subjEl.querySelectorAll(".av-chip:not(.av-sub)");
        return c.length>1?c[1+Math.floor(Math.random()*(c.length-1))]:null; },2600);
      scrollRun(3,720);
      steps.push([2000,function(){}]);
      mv(function(){ return subjEl.querySelector('.av-chip[data-s=""]'); },400);
      steps.push([200,function(){ window.scrollTo({top:0,behavior:"smooth"}); }]);
    } else if(r<0.70){  /* sweep the ratio slider: the whole grid re-sorts by shape */
      steps.push([200,function(){ window.scrollTo({top:0,behavior:"smooth"}); }]);
      mv(function(){ return $("#av-rslide"); },400);
      var sweep=[-1.6,-1.2,-0.8,-0.4,0,0.4,0.8,1.2,1.6];
      if(Math.random()<0.5) sweep.reverse();
      sweep.forEach(function(v){ steps.push([420,function(){
        var s=$("#av-rslide"); if(s){ s.value=v; s.dispatchEvent(new Event("input")); } }]); });
      steps.push([3600,function(){}]);
      mv(function(){ return $("#av-roff"); },600);   /* ratio off, back to number order */
    } else if(r<0.78){  /* the long dive — half the time oldest-first, so the early years show */
      if(Math.random()<0.5){
        mv(function(){ return sortEl; },300);
        steps.push([200,function(){ sortEl.value=pick(["numasc","old"]); sortEl.dispatchEvent(new Event("change")); }]);
      }
      scrollRun(5,860);
      steps.push([2000,function(){ if(sortEl.value!=="num"){ sortEl.value="num"; sortEl.dispatchEvent(new Event("change")); }
        window.scrollTo({top:0,behavior:"smooth"}); }]);
      steps.push([1200,function(){}]);
    } else if(r<0.92){  /* zoom expedition: filter to the big drawings, open one, wander inside it */
      mv(function(){ var chips=sizeEl.querySelectorAll(".av-chip");
        var want=Math.random()<0.5?"XL":"L";
        for(var i=0;i<chips.length;i++){ if(chips[i].getAttribute("data-z")===want) return chips[i]; }
        return chips.length>1?chips[chips.length-1]:null; },2200);
      mv(function(){ return pick(visibleItems())||(wrap&&wrap.querySelector(".av-item")); },2600);
      steps.push([200,function(){ var st=document.querySelector("#av-lb-stage .av-lb-cropwrap, #av-lb-stage img");
        if(!st) return;
        var rc=st.getBoundingClientRect();
        var px=rc.left+rc.width*(0.25+Math.random()*0.5), py=rc.top+rc.height*(0.25+Math.random()*0.5);
        AT.tgt=null; $("#av-ghost").style.transform="translate("+Math.round(px)+"px,"+Math.round(py)+"px)";
        AT.timers.push(setTimeout(function(){ if(!AT.on) return;
          var g=$("#av-ghost"); g.classList.remove("click"); void g.offsetWidth; g.classList.add("click");
          st.dispatchEvent(new MouseEvent("click",{clientX:px,clientY:py,bubbles:true,cancelable:true}));
        },950)); }]);
      steps.push([2400,function(){}]);
      for(var x2=0;x2<3;x2++){
        steps.push([400,function(){ var vp=document.querySelector(".av-zv"); if(!vp) return;
          var rc=vp.getBoundingClientRect();
          AT.zx=rc.left+rc.width*(0.2+Math.random()*0.6); AT.zy=rc.top+rc.height*(0.2+Math.random()*0.6);
          AT.tgt=null; $("#av-ghost").style.transform="translate("+Math.round(AT.zx)+"px,"+Math.round(AT.zy)+"px)"; }]);
        for(var wi=0;wi<6;wi++) steps.push([130,function(){ var vp=document.querySelector(".av-zv");
          if(vp) vp.dispatchEvent(new WheelEvent("wheel",{deltaY:-260,clientX:AT.zx,clientY:AT.zy,bubbles:true,cancelable:true})); }]);
        steps.push([2000,function(){}]);
        for(var wo=0;wo<4;wo++) steps.push([110,function(){ var vp=document.querySelector(".av-zv");
          if(vp) vp.dispatchEvent(new WheelEvent("wheel",{deltaY:300,clientX:AT.zx,clientY:AT.zy,bubbles:true,cancelable:true})); }]);
      }
      steps.push([500,function(){ var vp=document.querySelector(".av-zv");
        if(vp) vp.dispatchEvent(new MouseEvent("dblclick",{bubbles:true,cancelable:true})); }]);
      steps.push([900,function(){ var vp=document.querySelector(".av-zv");
        if(vp) vp.dispatchEvent(new MouseEvent("click",{bubbles:true,cancelable:true})); }]);
      mv(function(){ return $("#av-lb-close"); },600);
      mv(function(){ return sizeEl.querySelector('.av-chip[data-z=""]'); },500);
    } else {            /* time travel: browse into a year folder, look around, come home */
      mv(function(){ var fs=foldersEl.querySelectorAll(".av-folder");
        return fs.length?fs[Math.floor(Math.random()*Math.min(fs.length,6))]:null; },3800);
      scrollRun(2,760);
      mv(function(){ return pick(visibleItems()); },2600);
      steps.push([200,lbScrollToSimilar]);
      steps.push([1600,function(){}]);
      mv(function(){ return $("#av-lb-close"); },600);
      mv(function(){ return crumbsEl.querySelector("a"); },2200);   /* breadcrumb back to All Drawings */
    }
    steps.push([450,atScript]);
    (function run(idx){
      if(idx>=steps.length) return;
      AT.timers.push(setTimeout(function(){ if(!AT.on) return; steps[idx][1](); run(idx+1); },steps[idx][0]));
    })(0);
  }
  function atEnter(force){
    if(AT.on) return;
    if((!force&&document.hidden)||!view.length||view.length<8){ atArm(); return; }
    AT.on=true;
    var badge=$("#av-demo-badge"); if(badge) badge.classList.add("show");
    var g=$("#av-ghost");
    g.style.transform="translate("+Math.round(window.innerWidth/2)+"px,"+Math.round(window.innerHeight/2)+"px)";
    g.classList.add("show");
    atScript();
  }
  function atStop(){
    if(!AT.on){ atArm(); return; }
    AT.on=false;
    AT.timers.forEach(clearTimeout); AT.timers=[];
    var badge=$("#av-demo-badge"); if(badge) badge.classList.remove("show");
    var g=$("#av-ghost"); if(g) g.classList.remove("show","click");
    atArm();
  }
  ["pointerdown","pointermove","keydown","wheel","touchstart"].forEach(function(ev){
    window.addEventListener(ev,function(e){
      if(!e.isTrusted) return;         /* the demo's own synthetic events never wake it */
      if(AT.on) atStop(); else atArm();
    },{capture:true,passive:true});
  });
  window.addEventListener("scroll",function(){ if(!AT.on) atArm(); },{passive:true});
  document.addEventListener("visibilitychange",function(){ if(document.hidden) atStop(); else atArm(); });
  (function(){   /* Autoplay toggle */
    var anchor=$("#av-filters")||$("#av-count"); if(!anchor||$("#av-autoplay")) return;
    var b=document.createElement("button"); b.type="button"; b.id="av-autoplay"; b.className="av-chip av-autobtn";
    b.title="When on, the archive browses itself after a quiet minute and a half";
    function paint(){ b.classList.toggle("on",AT.enabled); b.setAttribute("aria-pressed",AT.enabled?"true":"false");
      b.innerHTML=(AT.enabled?"&#10074;&#10074;":"&#9654;")+" Autoplay"+(AT.enabled?" on":""); }
    b.onclick=function(){ AT.enabled=!AT.enabled;
      try{ localStorage.setItem("sxf-autoplay",AT.enabled?"1":"0"); }catch(e){}
      if(AT.enabled){ atArm(); toast("Autoplay on — the archive will browse itself when left alone"); }
      else { if(AT.on) atStop(); clearTimeout(AT.timer); AT.timer=null; toast("Autoplay off"); }
      paint(); };
    paint(); anchor.parentNode.insertBefore(b,anchor);
  })();
  window.__sxfDemo={enter:function(){atEnter(true);},stop:atStop,autoplay:function(){return {enabled:AT.enabled,armed:!!AT.timer,on:AT.on,search:location.search};}};   /* preview the idle demo without waiting 45s */
  atArm();
  wireRatio();
  loadSubjects();
  loadCrops();
  loadSizes();
  loadMeta();
  loadNeighbors();
  load();
})();
